import React, {useRef, useEffect, useState} from "react";
import Header from "../components/Header";
import Button from "react-bootstrap/Button";
import Slider from "react-slick";

import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../components/Footer";
import {useModal} from "../components/ModalContext";
import TypingEffect from "../components/TypingEffect/TypingEffect";
import MediaArticles from "../components/MediaArticles/MediaArticles";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ModalMushroomGrowth from "../components/Modal/ModalMushroomGrowth";

let img_play = require("../assets/home/play-button-icon.png");
let promo_fungo = require("../assets/home/promo-fungo.png");
let promo_experience = require("../assets/home/promo-experience.png");
let promo_map = require("../assets/home/promo-map.png");
let promo_experience2 = require("../assets/home/promo-experience2.png");
let promo_community = require("../assets/home/promo-community.png");
let promo_society = require("../assets/home/promo-society.png");
let promo_society2 = require("../assets/home/promo-society2.png");
let promo_feedback = require("../assets/home/promo-feedback.png");
let person = require("../assets/home/person.png");

let img_card_tickets = require("../assets/home/card-tickets.png");
let img1 = require("../assets/home/funghi.jpg");
let video_home = require("../assets/home/video_home.mp4");

let article_il_sole = require("../assets/home/articles/il-sole.png");
let article_republica = require("../assets/home/articles/repubblica.png");
let article_forbes = require("../assets/home/articles/forbes.webp");
let article_tirreno = require("../assets/home/articles/il-tirreno.png");

function Home() {
    const {openModal} = useModal();
    const cardRef = useRef(null);
    const [showModalGrowth, setShowModalGrowth] = useState(false);
    const handleCloseModalGrowth = () => setShowModalGrowth(false);
    const handleShowModalGrowth = () => setShowModalGrowth(true);

    function renderCardsVideo() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<div className="p-2">
                <div className="video-community">
                    <video autoPlay loop muted>
                        <source src={video_home} type="video/mp4"/>
                        Il tuo browser non supporta il video.
                    </video>
                </div>
            </div>);
        }
        return result;
    }

    function renderCardsTickets() {
        let result = [];

        for (let i = 0; i < 4; i++) {
            result.push(<div>
                <div className="card card-ticket m-2" ref={i === 0 ? cardRef : null}>
                    <img className="card-img-top" src={img1} alt="Card image cap"/>
                    <div className="card-body ">
                        <span>Funghi - Annuale</span><br/>
                        <span>Comunita' Montana di Valle Camonica</span><br/>
                        <span>Piazza Tassara Lombardia, Italia</span><br/>
                        <span>Tutti</span><br/>
                        <span>01/01/2024 - 31/12/2024</span><br/>
                        <span>80.00€</span><br/>
                        <div className={"mx-auto"}>
                            <a href="#" className="btn btn-success">Acquista</a>
                        </div>
                    </div>
                </div>
            </div>);
        }
        return result;
    }

    function renderArticles() {
        let articles = [
            {
                body: "La piattaforma di ticketing digitale avanzato che aggrega tutti i servizi degli sport e delle attività outdoor di montagna, attraverso uno strumento semplice da usare e accessibile a tutti.",
                name: "Forbes",
                img: article_forbes,
                stars: 5
            },
            {
                body: "La startup \"nata\" da un fungo che promette di rilanciare l’appennino",
                name: "la Repubblica",
                img: article_republica,
                stars: 5
            },
            {
                body: "Qualche click e il gioco è fatto: chi parte alla ricerca nei boschi con questo sistema è più sicuro",
                name: "Il Sole 24 Ore",
                img: article_il_sole,
                stars: 5
            },
            {
                body: "Un metodo che porta grossi vantaggi a beneficio dei clienti, del territorio e delle attività del comprensorio stesso.",
                name: "Il Tirreno",
                img:article_tirreno,
                stars: 5
            },
        ];
        let result = [];

        for (let article of articles) {
            result.push(<div>
                <div className="card card-article m-2">
                    <div className="card-body ">
                        <span>{article.body}</span><br/>
                        <div className={"d-flex align-items-center"}>
                            <div className={"article-person"}>
                                <img src={article.img} alt="" />
                            </div>
                            <span className={"article-name"}>{article.name}</span>
                        </div>
                    </div>
                </div>
            </div>);
        }
        return result;
    }

    let settingsSlider = {
        // dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: window.innerWidth < 768 ? 1 : 4,
        slidesToScroll: 1,
        autoplay: true,
    };

    let settingsSliderArticle = {
        // dots: true,
        slidesToShow: window.innerWidth < 768 ? 1 : 3,
        slidesToScroll: 1,
    };
    return (
        <div style={{backgroundColor: "#fafafa"}}>
            <Header/>
            <div className="video-section">
                <video autoPlay loop muted className="background-video">
                    <source src={video_home} type="video/mp4"/>
                    Il tuo browser non supporta il video.
                </video>

                <div className="overlay-content background">
                    <div>
                        <img className={"image-play"} src={img_play} alt="Card image cap"
                             onClick={() => openModal("video-home")}/>
                        <div style={{flex: 1}}>
                            <h1 className="title">Se vai a <TypingEffect texts={["funghi", "pesca", "sciare"]}/><br/><b>sei
                                nel posto giusto</b></h1>
                        </div>
                        <div className="buttons">
                            <Button className={"btn-orange"} style={{fontWeight: "bold", fontSize: 18}}
                                    onClick={handleShowModalGrowth}>Tabella crescita
                                funghi</Button>
                            <Button className={"btn-orange"} style={{fontWeight: "bold", fontSize: 18}}
                                    onClick={() => openModal("search")}>Acquista
                                permessi</Button>
                            <Button className={"btn-orange"} style={{fontWeight: "bold", fontSize: 18}} onClick={() => openModal("search")}>Prenota
                                esperienze</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"container-promo"}>
                    <div style={{backgroundImage: `url(${promo_fungo})`}} className="background-container" onClick={()=>setShowModalGrowth(true) }>
                        <h3>Tabella crescite<br/><b>intelligente</b></h3>
                        <span>Scopri dove stanno nascendo</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"} onClick={()=> setShowModalGrowth(true)}>Scopri di più</Button>
                        </div>
                    </div>
                    <div style={{backgroundImage: `url(${promo_experience})`}} className="background-container" onClick={()=>openModal("search")}>
                        <h3>Geoticket<br/><b>experience</b></h3>
                        <span>Regala o prenota le migliori esperienze all’aperto</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"}>Prenota ora</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"background  mt-2"} style={{backgroundImage: `url(${img_card_tickets})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Acquista il tuo permesso</h4>
                        <p>Sei indeciso? ecco alcuni suggerimenti...</p>
                    </div>

                    <div className="container p-4">
                        <Slider {...settingsSlider}>
                            {renderCardsTickets()}
                        </Slider>
                    </div>
                    <Button className={"btn-orange"} onClick={() => openModal("search")}>ACQUISTA IL TUO
                        PERMESSO</Button>
                </div>
            </div>

            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_map})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Scopri dove stanno nascendo</h4>
                        <p>Abbiamo creato per te una mappa intelligente,
                            che incrocia milioni di dati ambientali per prevedere
                            le prossime nascite.</p>
                    </div>
                    <div style={{height: 240}}></div>
                    <Button className={"btn-orange"} href={"/ai"}>PROVALA SUBITO</Button>
                </div>
            </div>
            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_experience2})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Regalati un’esperienza all’aperto</h4>
                        <p>Abbiamo selezionato per te le migliori esperienze di raccolta funghi in Italia</p>
                    </div>
                    <div style={{height: 240}}></div>
                    <Button className={"btn-orange"} onClick={() => openModal("search")}>PRENOTA ORA</Button>
                </div>
            </div>

            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_community})`}}>
                <div className={"container container-list"}>
                    <div className={"container-title"}>
                        <h4>Entra nella nostra community</h4>
                        <p>Condividi con noi i tuoi video: li pubblicheremo sui nostri canali!</p>
                    </div>
                    <div className="container p-4">
                        <Slider {...settingsSlider}>
                            {renderCardsVideo()}
                        </Slider>
                    </div>
                    <Button className={"btn-orange"}>ISCRIVITI SUBITO</Button>
                </div>
            </div>

            <div className={"container"}>
                <div className={"container-promo"}>
                    <div style={{backgroundImage: `url(${promo_society})`}} className="background-container" onClick={()=> window.location.href = "/contact"}>
                        <h3>Gestisci <b>un Ente?</b></h3>
                        <span>Scopri come vendere i tuoi permessi e ticket con un click</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"} href={"/contact"}>CONTATTACI</Button>
                        </div>
                    </div>
                    <div style={{backgroundImage: `url(${promo_society2})`}} className="background-container" onClick={()=> window.location.href = "/contact"}>
                        <h3>Hai <b>un’attività commerciale?</b></h3>
                        <span>Vendi permessi e ticket direttamente dal tuo punto vendita</span>
                        <div className={"button-container"}>
                            <Button className={"btn-orange"} href={"/contact"}>CONTATTACI</Button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={"background mt-2"} style={{backgroundImage: `url(${promo_feedback})`}}>
                <div className={"container-list"}>
                    <div className={"container-title"}>
                        <h4>Dicono di noi...</h4>
                    </div>
                    <div className="container p-4">
                        <Slider {...settingsSliderArticle}>
                            {renderArticles()}
                        </Slider>
                    </div>
                    <div className={"container"}>
                        <MediaArticles/>
                    </div>
                </div>
            </div>
            {/*
            <div style={{width: '100%', height: 420, position: 'relative'}}>
                <div id='map-container' className={"map"} ref={mapContainerRef}/>
                <div className="map-overlay">
                    <h4>scopri dove stanno nascendo</h4>
                    <span>La nostra mappa intelligente incrocia milioni di dati ambientali per prevedere le prossime nascite. <br/>Provala subito!</span>
                </div>
            </div>*/}

            <ModalMushroomGrowth show={showModalGrowth} onHide={handleCloseModalGrowth}/>

            <Footer/>
        </div>
    );
}

export default Home;